import { request } from 'sonata-react-components';

import type {
  DeviceCarrierApiResponse,
  DeviceMakeModelBidderDashboardResponse
} from 'sonata-static-storage/lib/common/common.types';
import type { DeviceMakeModelBidderRequestType } from 'sonata-static-storage/lib/schemas/targeting/DeviceMakeModel/DeviceMakeModels.types';

export function fetchDeviceMakeModels(
  deviceTypes: DeviceMakeModelBidderRequestType[],
  token: Record<string, any>
): Promise<DeviceMakeModelBidderDashboardResponse[]> {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}resources/deviceMakeModels`,
    {
      method: 'GET',
      params: {
        deviceTypes,
        itemsPerPage: 100000
      }
    },
    token
  );
}

export function fetchDeviceCarriers(): Promise<Record<string, DeviceCarrierApiResponse>> {
  return request.makeRequest(`${taptap.config.backendUrlBase}resources/deviceCarriers`, {
    method: 'GET'
  });
}

export async function fetchDeviceOs(deviceTypes: DeviceMakeModelBidderRequestType[], token: Record<string, any>) {
  return request.makeRequest(
    `${taptap.config.backendUrlBase}resources/deviceOs`,
    {
      method: 'GET',
      params: {
        deviceTypes,
        itemsPerPage: 100000
      }
    },
    token
  );
}
